import React, { Component } from "react"
import { COLOR, IMG } from "../../themes"
import { TOAST_STYLE_COPY } from "./style"
import { TOAST_MESSAGE } from "../../helpers"
class ToastCopy extends Component {
  render() {
    const {
      onClickCloseToast,
      isOpenToast,
      language = 'EN'
    } = this.props
    
    return (
      <React.Fragment>
        {isOpenToast && (
          <TOAST_STYLE_COPY style={{ background: COLOR.GRAY_23 }}>
            <p className='message'>{TOAST_MESSAGE.COPY[language]}</p>
            <div className='divider' />
            <img
              className='close-btn'
              src={IMG["close-white.svg"]}
              alt='close-btn'
              onClick={onClickCloseToast}
            />
          </TOAST_STYLE_COPY>
        )}
      </React.Fragment>
    )
  }
}

export default ToastCopy
